'use client'
import Image from 'next/image';
import React, { useState, useEffect } from 'react';

export default function MachineSpecificGalleryTwo({ data }) {
    // Main gallery shows up to 6 images.
    const mainImages = data.slice(0, 6);
    const allImages = [...data]; // duplicated images for view all

    // State for modals
    const [viewAllOpen, setViewAllOpen] = useState(false);
    const [zoomedIndex, setZoomedIndex] = useState(null);

    // Open/close functions for the modals
    const openViewAll = () => {
        setViewAllOpen(true);
    };

    const closeViewAll = () => {
        setViewAllOpen(false);
    };

    const openZoomed = (index) => {
        setZoomedIndex(index);
    };

    const closeZoomed = () => {
        setZoomedIndex(null);
    };

    // Navigate left/right in zoomed modal
    const navigateZoomed = (direction) => {
        setZoomedIndex((prev) => {
            if (prev === null) return 0;
            if (direction === 'prev') {
                return prev > 0 ? prev - 1 : allImages.length - 1;
            } else if (direction === 'next') {
                return prev < allImages.length - 1 ? prev + 1 : 0;
            }
            return prev;
        });
    };

    // Disable body scrolling when either modal is open
    useEffect(() => {
        if (viewAllOpen || zoomedIndex !== null) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [viewAllOpen, zoomedIndex]);

    return (
        <div className='section-wrapper'>
            <div className='machine-specific-gallery__container'>

                <div className="machine-specific-gallery">
                    <div className="machine-specific-gallery__grid">
                        {mainImages.map((img, index) => (
                            <div
                                key={`${img.id}-${index}`}
                                className="machine-specific-gallery__image-wrapper"
                                onClick={() => openZoomed(index)}
                            >
                                <Image
                                    src={img.fileLink}
                                    width={800}
                                    height={800} // assuming 1:1 ratio images
                                    alt={img.alt || 'Image'}
                                    className="machine-specific-gallery__image"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <button className="machine-specific-gallery__view-all-button" onClick={openViewAll}>
                    View All Images
                </button>

                {viewAllOpen && (
                    <div className="machine-specific-gallery__view-all-modal" onClick={closeViewAll}>

                        <div className="machine-specific-gallery__view-all-modal__grid">
                            <div
                                className="machine-specific-gallery__view-all-modal__grid__close"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeViewAll();
                                }}
                            >
                                ×
                            </div>
                            {allImages.map((img, index) => (
                                <div
                                    key={`${img.id}-${index}`}
                                    className="machine-specific-gallery__view-all-modal__grid__image-wrapper"
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent closing the view all modal
                                        openZoomed(index);
                                    }}
                                >
                                    <Image
                                        src={img.fileLink}
                                        width={400}
                                        height={400} // 1:1 ratio
                                        alt={img.alt || 'Image'}
                                        className="machine-specific-gallery__view-all-modal__grid__image-wrapper__image"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {zoomedIndex !== null && (
                    <div
                        className="machine-specific-gallery__view-individual-image-modal"
                        onClick={closeZoomed}
                    >
                        <div
                            className="machine-specific-gallery__view-individual-image-modal__content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="machine-specific-gallery__view-individual-image-modal__content__image-wrapper">
                                <div
                                    className="machine-specific-gallery__view-individual-image-modal__content__image-wrapper__close"
                                    onClick={closeZoomed}
                                >
                                    ×
                                </div>
                                <div
                                    className="machine-specific-gallery__view-individual-image-modal__content__image-wrapper__arrow left"
                                    onClick={() => navigateZoomed('prev')}
                                >
                                    &lt;
                                </div>
                                <div
                                    className="machine-specific-gallery__view-individual-image-modal__content__image-wrapper__arrow right"
                                    onClick={() => navigateZoomed('next')}
                                >
                                    &gt;
                                </div>
                                <Image
                                    src={allImages[zoomedIndex].fileLink}
                                    width={1920}
                                    height={1920}
                                    alt={allImages[zoomedIndex].alt || ''}
                                    className="machine-specific-gallery__view-individual-image-modal__content__image-wrapper__image"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
